import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../Shared/Modals/Header";
import { Dialog, DialogContent, DialogActions, Button, ButtonGroup } from "@material-ui/core";
import { Close, Check } from "@material-ui/icons";
import materializedViewActions from "../../../redux/actions/materializedView";
import SearchForm from "./Form/SearchForm";

export default function KiloViewDownloaderModal() {
    const dispatch = useDispatch();
    const materializedView = useSelector((state) => state.materializedView);
    const app = useSelector((state) => state.app);

    const handleClose = () => {
        dispatch(materializedViewActions.setViewKiloDiarioModal(false));
    };

    const handleSuccess = () => {
        if (!form.dateInit || !form.dateFinish) {
            return;
        }
        if (form.dateFinish < form.dateInit) {
            return;
        }

        dispatch(materializedViewActions.downloadKiloDiario(form));
    };

    const [form, setForm] = useState({
        dateInit: '',
        dateFinish: '',
        locals: [],
        materials: []
    });

    return (
        <Dialog
            open={materializedView.viewKiloDiarioModal}
            onClose={() => handleClose()}
            aria-labelledby="responsive-dialog-title"
            scroll={"body"}
            maxWidth="sm"
            fullWidth
        >
            <DialogContent>
                <Header handleClose={handleClose} type="VIEW" title="Reporte kilos diarios" />
                <SearchForm formData={form} setFormData={setForm} dateType={true} />
            </DialogContent>
            <DialogActions>
                <ButtonGroup size="small" variant="contained">
                    <Button
                        onClick={() => handleClose()}
                        color="secondary"
                        startIcon={<Close />}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => handleSuccess()}
                        color="primary"
                        startIcon={<Check />}
                        disabled={app.loading}
                    >
                        Descargar
                    </Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>
    )
};